function escapeForInlineJson(data) {
  return JSON.stringify(data).replace(/</g, "\\u003c");
}

const REPORT_CSS = [
  "* { box-sizing: border-box; }",
  ":root { --primary: #093390; --primary-dark: #062a80; --secondary: #FF6700; --secondary-dark: #e05500; --ink: #0f172a; --muted: #64748b; --border: #e5e9f0; --bg: #eef1f8; }",
  "body { margin: 0; font-family: 'Segoe UI', system-ui, -apple-system, Roboto, Arial, sans-serif; background-color: var(--bg); color: var(--ink); }",
  "",
  ".header { background: linear-gradient(135deg, var(--primary) 0%, #0b48c4 100%); color: #fff; padding: 36px 28px 30px; position: relative; overflow: hidden; }",
  ".header::after { content: ''; position: absolute; right: -60px; top: -60px; width: 220px; height: 220px; border-radius: 50%; background: rgba(255,103,0,0.18); }",
  ".header-inner { position: relative; max-width: 1100px; margin: 0 auto; }",
  ".header-eyebrow { display: inline-block; font-size: 11px; font-weight: 700; letter-spacing: 1.2px; text-transform: uppercase; color: var(--secondary); background: rgba(255,255,255,0.12); padding: 4px 12px; border-radius: 999px; margin-bottom: 12px; }",
  ".header h1 { margin: 0 0 6px; font-size: 26px; font-weight: 800; letter-spacing: -0.3px; }",
  ".header p { margin: 0; font-size: 13px; color: rgba(255,255,255,0.75); }",
  "",
  ".content { max-width: 1100px; margin: -26px auto 0; padding: 0 24px 40px; position: relative; }",
  "",
  ".stats { display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; margin-bottom: 22px; }",
  ".statCard { background: #fff; border-radius: 16px; padding: 18px 20px; box-shadow: 0 10px 30px rgba(15,23,42,0.08); border: 1px solid var(--border); }",
  ".statCard .statLabel { font-size: 12px; color: var(--muted); font-weight: 600; text-transform: uppercase; letter-spacing: 0.4px; margin-bottom: 6px; }",
  ".statCard .statValue { font-size: 28px; font-weight: 800; color: var(--primary); }",
  ".statCard.accent .statValue { color: var(--secondary); }",
  ".statCard.muted .statValue { color: var(--muted); }",
  "",
  ".toolbar { display: flex; gap: 12px; flex-wrap: wrap; align-items: center; margin-bottom: 14px; }",
  ".searchWrapper { flex: 1; min-width: 240px; position: relative; }",
  ".searchWrapper svg { position: absolute; left: 14px; top: 50%; transform: translateY(-50%); opacity: 0.45; }",
  "#searchInput { width: 100%; padding: 12px 14px 12px 40px; border: 1.5px solid var(--border); border-radius: 12px; font-size: 14px; outline: none; background: #fff; transition: border-color 0.2s ease, box-shadow 0.2s ease; }",
  "#searchInput:focus { border-color: var(--secondary); box-shadow: 0 0 0 4px rgba(255,103,0,0.12); }",
  "#drawBtn { display: inline-flex; align-items: center; gap: 8px; padding: 12px 22px; background: linear-gradient(135deg, var(--secondary), var(--secondary-dark)); color: #fff; border: none; border-radius: 12px; font-weight: 700; font-size: 14px; cursor: pointer; white-space: nowrap; box-shadow: 0 8px 20px rgba(255,103,0,0.35); transition: transform 0.15s ease, box-shadow 0.15s ease; }",
  "#drawBtn:hover { transform: translateY(-2px); box-shadow: 0 10px 24px rgba(255,103,0,0.45); }",
  "#drawBtn:active { transform: translateY(0); }",
  "",
  "#countInfo { font-size: 13px; color: var(--muted); margin-bottom: 14px; font-weight: 500; }",
  "",
  "#drawResult { display: none; align-items: center; gap: 10px; background: #fff; border: 2px solid var(--secondary); color: var(--primary); font-weight: 700; font-size: 15px; padding: 14px 18px; border-radius: 14px; margin-bottom: 18px; box-shadow: 0 10px 26px rgba(255,103,0,0.18); animation: popIn 0.35s ease; }",
  "@keyframes popIn { from { opacity: 0; transform: scale(0.95) translateY(-4px); } to { opacity: 1; transform: scale(1) translateY(0); } }",
  "",
  ".tableWrapper { overflow-x: auto; background-color: #fff; border-radius: 16px; box-shadow: 0 10px 30px rgba(15,23,42,0.08); border: 1px solid var(--border); }",
  "table { width: 100%; border-collapse: collapse; font-size: 13.5px; min-width: 760px; }",
  "th, td { text-align: left; padding: 13px 16px; white-space: nowrap; }",
  "th { background-color: #f8fafc; color: var(--primary); font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; position: sticky; top: 0; border-bottom: 2px solid var(--border); }",
  "tbody tr { border-bottom: 1px solid var(--border); transition: background-color 0.15s ease; }",
  "tbody tr:last-child { border-bottom: none; }",
  "tbody tr:nth-child(even) { background-color: #fafbfd; }",
  "tbody tr:hover { background-color: #eef4ff; }",
  "tbody tr.winner { background-color: #fff4ea !important; box-shadow: inset 0 0 0 2px var(--secondary); animation: pulse 1s ease 2; }",
  "@keyframes pulse { 0%, 100% { background-color: #fff4ea; } 50% { background-color: #ffe4c7; } }",
  "",
  ".badge { display: inline-block; padding: 4px 11px; border-radius: 999px; font-size: 12px; font-weight: 700; }",
  ".badge-yes { background-color: #dcfce7; color: #16a34a; }",
  ".badge-no { background-color: #f1f5f9; color: #94a3b8; }",
  ".badge-permission-sim { background-color: #e0e9ff; color: var(--primary); }",
  ".badge-permission-nao { background-color: #fee2e2; color: #dc2626; }",
  "",
  ".emptyState { text-align: center; padding: 48px 20px; color: var(--muted); font-size: 14px; }",
  "",
  ".footer { max-width: 1100px; margin: 22px auto 0; padding: 0 24px; text-align: center; color: var(--muted); font-size: 12px; }",
  "",
  "@media screen and (max-width: 640px) {",
  "  .stats { grid-template-columns: 1fr; }",
  "  .header { padding: 28px 18px 24px; }",
  "  .content { padding: 0 14px 32px; }",
  "}",
].join("\n");

const REPORT_JS = [
  "var data = JSON.parse(document.getElementById('report-data').textContent);",
  "var tbody = document.getElementById('reportBody');",
  "var searchInput = document.getElementById('searchInput');",
  "var countEl = document.getElementById('countInfo');",
  "var drawBtn = document.getElementById('drawBtn');",
  "var drawResult = document.getElementById('drawResult');",
  "var totalStat = document.getElementById('statTotal');",
  "var withdrawnStat = document.getElementById('statWithdrawn');",
  "var pendingStat = document.getElementById('statPending');",
  "",
  "var withdrawnCount = data.filter(function (item) { return item.withdrawn; }).length;",
  "totalStat.textContent = data.length;",
  "withdrawnStat.textContent = withdrawnCount;",
  "pendingStat.textContent = data.length - withdrawnCount;",
  "",
  "function formatDate(iso) {",
  "  if (!iso) return '';",
  "  var d = new Date(iso);",
  "  return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });",
  "}",
  "",
  "function renderRows(list) {",
  "  tbody.innerHTML = '';",
  "",
  "  if (list.length === 0) {",
  "    var emptyTr = document.createElement('tr');",
  "    var emptyTd = document.createElement('td');",
  "    emptyTd.colSpan = 7;",
  "    emptyTd.className = 'emptyState';",
  "    emptyTd.textContent = 'Nenhum cadastro encontrado.';",
  "    emptyTr.appendChild(emptyTd);",
  "    tbody.appendChild(emptyTr);",
  "    countEl.textContent = '0 de ' + data.length + ' cadastros';",
  "    return;",
  "  }",
  "",
  "  list.forEach(function (item) {",
  "    var tr = document.createElement('tr');",
  "    tr.setAttribute('data-ticket', item.ticket);",
  "",
  "    var nameTd = document.createElement('td');",
  "    nameTd.textContent = item.name || '';",
  "    tr.appendChild(nameTd);",
  "",
  "    var phoneTd = document.createElement('td');",
  "    phoneTd.textContent = item.phone || '';",
  "    tr.appendChild(phoneTd);",
  "",
  "    var vehicleTd = document.createElement('td');",
  "    vehicleTd.textContent = item.vehicleType || '';",
  "    tr.appendChild(vehicleTd);",
  "",
  "    var permissionTd = document.createElement('td');",
  "    var permissionBadge = document.createElement('span');",
  "    permissionBadge.className = 'badge ' + (item.permission === 'Sim' ? 'badge-permission-sim' : 'badge-permission-nao');",
  "    permissionBadge.textContent = item.permission || '';",
  "    permissionTd.appendChild(permissionBadge);",
  "    tr.appendChild(permissionTd);",
  "",
  "    var withdrawnTd = document.createElement('td');",
  "    var withdrawnBadge = document.createElement('span');",
  "    withdrawnBadge.className = 'badge ' + (item.withdrawn ? 'badge-yes' : 'badge-no');",
  "    withdrawnBadge.textContent = item.withdrawn ? 'Sim' : 'Não';",
  "    withdrawnTd.appendChild(withdrawnBadge);",
  "    tr.appendChild(withdrawnTd);",
  "",
  "    var ticketTd = document.createElement('td');",
  "    ticketTd.textContent = item.ticket || '';",
  "    tr.appendChild(ticketTd);",
  "",
  "    var dateTd = document.createElement('td');",
  "    dateTd.textContent = formatDate(item.createdAt);",
  "    tr.appendChild(dateTd);",
  "",
  "    tbody.appendChild(tr);",
  "  });",
  "",
  "  countEl.textContent = list.length + ' de ' + data.length + ' cadastros';",
  "}",
  "",
  "function getFiltered() {",
  "  var term = searchInput.value.trim().toLowerCase();",
  "  if (!term) return data;",
  "  return data.filter(function (item) {",
  "    return (",
  "      (item.name && item.name.toLowerCase().indexOf(term) !== -1) ||",
  "      (item.phone && item.phone.toLowerCase().indexOf(term) !== -1) ||",
  "      (item.vehicleType && item.vehicleType.toLowerCase().indexOf(term) !== -1)",
  "    );",
  "  });",
  "}",
  "",
  "searchInput.addEventListener('input', function () {",
  "  renderRows(getFiltered());",
  "  drawResult.style.display = 'none';",
  "});",
  "",
  "drawBtn.addEventListener('click', function () {",
  "  var pool = getFiltered();",
  "  if (pool.length === 0) {",
  "    drawResult.style.display = 'flex';",
  "    drawResult.textContent = 'Nenhum participante para sortear.';",
  "    return;",
  "  }",
  "",
  "  var winner = pool[Math.floor(Math.random() * pool.length)];",
  "  drawResult.style.display = 'flex';",
  "  drawResult.textContent = '🎉 Sorteado: ' + winner.name + ' — ' + winner.phone + ' (código ' + winner.ticket + ')';",
  "",
  "  Array.prototype.forEach.call(document.querySelectorAll('#reportBody tr'), function (tr) {",
  "    tr.classList.remove('winner');",
  "  });",
  "",
  "  var row = document.querySelector('#reportBody tr[data-ticket=\"' + winner.ticket + '\"]');",
  "  if (row) {",
  "    row.classList.add('winner');",
  "    row.scrollIntoView({ behavior: 'smooth', block: 'center' });",
  "  }",
  "});",
  "",
  "renderRows(data);",
].join("\n");

export function generateQrReportHtml(data) {
  const generatedAt = new Date().toLocaleString("pt-BR");

  return [
    "<!DOCTYPE html>",
    '<html lang="pt-BR">',
    "<head>",
    '<meta charset="UTF-8">',
    '<meta name="viewport" content="width=device-width, initial-scale=1.0">',
    "<title>Relatório Agrega+GH - Inscritos</title>",
    "<style>",
    REPORT_CSS,
    "</style>",
    "</head>",
    "<body>",
    '<div class="header">',
    '<div class="header-inner">',
    '<span class="header-eyebrow">GH Solucionador Logístico</span>',
    "<h1>Relatório — Agrega + GH 2026</h1>",
    "<p>Gerado em " + generatedAt + "</p>",
    "</div>",
    "</div>",
    '<div class="content">',
    '<div class="stats">',
    '<div class="statCard"><div class="statLabel">Total de cadastros</div><div class="statValue" id="statTotal">0</div></div>',
    '<div class="statCard accent"><div class="statLabel">Retiraram o churrasco</div><div class="statValue" id="statWithdrawn">0</div></div>',
    '<div class="statCard muted"><div class="statLabel">Ainda não retiraram</div><div class="statValue" id="statPending">0</div></div>',
    "</div>",
    '<div class="toolbar">',
    '<div class="searchWrapper">',
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="7" stroke="#0f172a" stroke-width="2"/><path d="M21 21l-4.3-4.3" stroke="#0f172a" stroke-width="2" stroke-linecap="round"/></svg>',
    '<input type="text" id="searchInput" placeholder="Buscar por nome, telefone ou veículo...">',
    "</div>",
    '<button type="button" id="drawBtn">🎲 Sortear participante</button>',
    "</div>",
    '<div id="countInfo"></div>',
    '<div id="drawResult"></div>',
    '<div class="tableWrapper">',
    "<table>",
    "<thead><tr>",
    "<th>Nome</th><th>Telefone</th><th>Veículo e conjunto</th><th>Permisso</th><th>Retirou o churrasco</th><th>Código</th><th>Cadastrado em</th>",
    "</tr></thead>",
    '<tbody id="reportBody"></tbody>',
    "</table>",
    "</div>",
    "</div>",
    '<div class="footer">Relatório interno — GH Solucionador Logístico</div>',
    '<script id="report-data" type="application/json">' + escapeForInlineJson(data) + "</scr" + "ipt>",
    "<script>",
    REPORT_JS,
    "</scr" + "ipt>",
    "</body>",
    "</html>",
  ].join("\n");
}
